var map = {
	"./almeriaLogo.jpg": 7239,
	"./arsnalLogo.jpg": 2968,
	"./astonbillaLogo.jpg": 1204,
	"./atalantaLogo.jpg": 1024,
	"./atmLogo.jpg": 206,
	"./augsburgLogo.jpg": 9175,
	"./barcelronaLogo.jpg": 2592,
	"./benficaLogo.jpg": 3914,
	"./berlinLogo.jpg": 2039,
	"./betisLogo.jpg": 2964,
	"./bilbaoLogo.jpg": 8657,
	"./bochumLogo.jpg": 4569,
	"./bolognaLogo.jpg": 3747,
	"./bournemouthLogo.jpg": 5507,
	"./bremenLogo.jpg": 7167,
	"./brentfordLogo.jpg": 6549,
	"./brightonLogo.jpg": 2617,
	"./bruggeLogo.jpg": 1455,
	"./bundesligaLogo.jpg": 8254,
	"./cadizLogo.jpg": 1377,
	"./celtavigoLogo.jpg": 7775,
	"./chamsLogo.jpg": 768,
	"./chelseaLogo.jpg": 4826,
	"./cremoneseLogo.jpg": 7045,
	"./dortmundLogo.jpg": 3376,
	"./elcheLogo.jpg": 9621,
	"./empoliLogo.jpg": 6363,
	"./eplLogo.jpg": 7405,
	"./espanyolLogo.jpg": 2683,
	"./evertonLogo.jpg": 6826,
	"./fiolentinaLogo.jpg": 8506,
	"./frankfurtLogo.jpg": 36,
	"./freiburgLogo.jpg": 1528,
	"./fulhamLogo.jpg": 3949,
	"./getafeLogo.jpg": 4586,
	"./gironaLogo.jpg": 9455,
	"./herthaLogo.jpg": 4797,
	"./hoffenheimLogo.jpg": 437,
	"./interLogo.jpg": 9382,
	"./juventusLogo.jpg": 762,
	"./kolnLogo.jpg": 5967,
	"./laligaLogo.jpg": 4168,
	"./lazioLogo.jpg": 7327,
	"./leedsLogo.jpg": 9677,
	"./leipzigLogo.jpg": 1873,
	"./leisterLogo.jpg": 4612,
	"./leverkusenLogo.jpg": 6570,
	"./liverpoolLogo.jpg": 3923,
	"./madridLogo.jpg": 8695,
	"./maianzLogo.jpg": 7019,
	"./mallorcaLogo.jpg": 4607,
	"./mancityLogo.jpg": 6861,
	"./manuLogo.jpg": 69,
	"./millanLogo.jpg": 8261,
	"./monchenLogo.jpg": 1754,
	"./monzaLogo.jpg": 808,
	"./munichLogo.jpg": 2489,
	"./napoliLogo.jpg": 9121,
	"./newcastleLogo.jpg": 6695,
	"./nottinghamLogo.jpg": 8189,
	"./osasunaLogo.jpg": 8588,
	"./palaceLogo.jpg": 8172,
	"./portoLogo.jpg": 1604,
	"./psgLogo.jpg": 5740,
	"./psvLogo.jpg": 3810,
	"./recceLogo.jpg": 20,
	"./romeLogo.jpg": 3192,
	"./salernitanaLogo.jpg": 1275,
	"./sampdoriaLogo.jpg": 2710,
	"./sassuoloLogo.jpg": 8941,
	"./schalkeLogo.jpg": 4493,
	"./serieLogo.jpg": 3293,
	"./sevillaLogo.jpg": 4174,
	"./sociedadLogo.jpg": 1973,
	"./southhamtonLogo.jpg": 5974,
	"./speziaLogo.jpg": 5299,
	"./stuttgartLogo.jpg": 9689,
	"./torinoLogo.jpg": 7971,
	"./tottenhamLogo.jpg": 3793,
	"./udineseLogo.jpg": 756,
	"./valenciaLogo.jpg": 7581,
	"./valladolidLogo.jpg": 3456,
	"./vallecanoLogo.jpg": 2143,
	"./veronaLogo.jpg": 7835,
	"./villarrealLogo.jpg": 467,
	"./westhamLogo.jpg": 9223,
	"./wolfsburgLogo.jpg": 2195,
	"./woverhamtonLogo.jpg": 9799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4626;